var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 261.14,
    height: 81.61,
    viewBox: "0 0 261.14 81.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Square_Reverse_logotype",
    "data-name": "Square Reverse logotype",
    transform: "translate(-18.53 -17.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M98.53,76.38V58.55H91.91l-18.76,20-18.78,20H77.73Z",
    fill: "#ff3466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M98.53,18.55H51.62L18.53,53.81V78.55h7.92l37.54-40h7.78L18.53,95.28v3.27H46.59L98.53,43.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M37.07,18.55H18.53v20h6.54l12-12.78Z",
    fill: "#ff3466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M117.07,24.69V18.57h8.07v6.12h-8.07Zm0,29.84V27.56h8.07V54.53Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M167.91,36.11c0,9.67-7.1,19.15-19.2,19.15a18.839,18.839,0,0,1-19.1-18.86c0-10.55,8.8-18.52,19.25-18.52,8.12,0,15.94,5.49,17.98,12.73h-10.3a8.839,8.839,0,0,0-7.92-4.67c-5.78,0-9.82,4.67-9.82,10.45s3.79,10.79,9.87,10.79c4.28,0,7.48-2.09,8.6-5.78H146.53V34.06h21.38V36.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M192.22,54.53V51.61h-.1c-1.17,2.38-4.37,3.84-7.92,3.84-7.97,0-13.51-6.27-13.51-14.43s5.78-14.38,13.51-14.38c3.3,0,6.37,1.31,7.92,3.79h.1V27.56h8.07V54.53Zm0-13.51a6.841,6.841,0,0,0-6.85-6.85,6.667,6.667,0,0,0-6.61,6.95,6.644,6.644,0,0,0,6.71,6.8A6.763,6.763,0,0,0,192.22,41.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M239.25,54.53V40c0-4.23-1.36-5.78-4.13-5.78-3.06,0-4.47,1.85-4.47,5.39V54.53h-8.07V39.66c0-3.5-1.26-5.44-4.03-5.44-3.16,0-4.57,2.04-4.57,5.78V54.53h-8.07V27.56h7.53v2.87h.1c1.41-2.53,3.99-3.79,7.44-3.79a8.576,8.576,0,0,1,7.78,4.81,9.762,9.762,0,0,1,8.55-4.81c6.03,0,10.01,3.69,10.01,11.23V54.54h-8.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M259.26,43.5a6.036,6.036,0,0,0,6.32,5.1,5.672,5.672,0,0,0,4.91-2.53h8.26c-2.58,5.88-7.48,9.33-13.17,9.33a14.386,14.386,0,0,1-.15-28.77c7.92,0,14.24,6.37,14.24,14.73a10.718,10.718,0,0,1-.19,2.14Zm12.34-5.44a6.37,6.37,0,0,0-12.25,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M146.55,98.57l.29-26.92-.1-.1-7.68,27.02h-6.08L125.2,71.31l.29,27.26h-8.46V62.61h11.81l7.14,23.67h.1l7.05-23.67h11.86V98.57h-8.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M167.56,87.54a6.036,6.036,0,0,0,6.32,5.1,5.672,5.672,0,0,0,4.91-2.53h8.26c-2.58,5.88-7.48,9.33-13.17,9.33a14.386,14.386,0,0,1-.15-28.77c7.92,0,14.24,6.37,14.24,14.73a10.719,10.719,0,0,1-.19,2.14H167.56ZM179.9,82.1a6.37,6.37,0,0,0-12.25,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M212.4,98.57V95.65h-.1c-1.51,2.48-4.23,3.79-8.07,3.79-8.17,0-13.51-6.27-13.51-14.43s5.49-14.34,13.37-14.34a10.457,10.457,0,0,1,7.92,3.21V62.6h8.07V98.56H212.4Zm.05-13.61a6.679,6.679,0,0,0-6.85-6.76,6.522,6.522,0,0,0-6.8,6.76,6.7,6.7,0,0,0,6.76,6.95,6.783,6.783,0,0,0,6.9-6.95Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M225.68,68.73V62.61h8.07v6.12Zm0,29.84V71.6h8.07V98.57Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M259.51,98.57V95.65h-.1c-1.17,2.38-4.37,3.84-7.92,3.84-7.97,0-13.51-6.27-13.51-14.43s5.78-14.38,13.51-14.38c3.3,0,6.37,1.31,7.92,3.79h.1V71.6h8.07V98.57Zm0-13.51a6.841,6.841,0,0,0-6.85-6.85,6.879,6.879,0,0,0,.1,13.75A6.763,6.763,0,0,0,259.51,85.06Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgmLogo);
export default __webpack_public_path__ + "static/media/igm_logo.4018a343ba51f135bacbd7e29e19c17b.svg";
export { ForwardRef as ReactComponent };